import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'confirmation-popup-cancel',
  templateUrl: './confirmation-popup-cancel.component.html',
  styleUrls: ['./confirmation-popup-cancel.component.scss']
})
export class ConfirmationPopupCancelComponent {

  constructor(public dialogRef: MatDialogRef<ConfirmationPopupCancelComponent>,) { }

  yesSubmit() {
    this.dialogRef.close({ response: "success" });
  }
}
